
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "export--import-apis-for-hdfs-path"
    }}>{`Export & Import APIs for HDFS Path`}</h1>
    <h3 {...{
      "id": "introduction"
    }}>{`Introduction`}</h3>
    <p>{`The general approach for using the Import-Export APIs for HDFS Paths remain the same. There are minor variations caused how HDFS paths are handled within Atlas.`}</p>
    <p>{`Unlike HIVE entities, HDFS entities within Atlas are created manually using the `}<em parentName="p">{`Create Entity`}</em>{` link within the Atlas Web UI.`}</p>
    <p>{`Also, HDFS paths tend to be hierarchical, in the sense that users tend to model the same HDFS storage structure within Atlas.`}</p>
    <p><strong parentName="p">{`Sample HDFS Setup`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`HDFS Path`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Atlas Entity`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em>{`/apps/warehouse/finance`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Entity type: `}</strong><em>{`hdfs_path`}</em><br /><strong parentName="td">{`Name: `}</strong><em>{`Finance`}</em><br /><strong parentName="td">{`QualifiedName: `}</strong><em>{`FinanceAll`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em>{`/apps/warehouse/finance/accounts-receivable`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Entity type: `}</strong><em>{`hdfs_path`}</em><br /><strong parentName="td">{`Name: `}</strong><em>{`FinanceReceivable`}</em><br /><strong parentName="td">{`QualifiedName: `}</strong><em>{`FinanceReceivable`}</em><br /><strong parentName="td">{`Path: `}</strong><em>{`/apps/warehouse/finance`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em>{`/apps/warehouse/finance/accounts-payable`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Entity type: `}</strong><em>{`hdfs_path`}</em><br /><strong parentName="td">{`Name: `}</strong><em>{`Finance-Payable`}</em><br /><strong parentName="td">{`QualifiedName: `}</strong><em>{`FinancePayable`}</em><br /><strong parentName="td">{`Path: `}</strong><em>{`/apps/warehouse/finance/accounts-payable`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><em>{`/apps/warehouse/finance/billing`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Entity type: `}</strong><em>{`hdfs_path`}</em><br /><strong parentName="td">{`Name: `}</strong><em>{`FinanceBilling`}</em><br /><strong parentName="td">{`QualifiedName: `}</strong><em>{`FinanceBilling`}</em><br /><strong parentName="td">{`Path: `}</strong><em>{`/apps/warehouse/finance/billing`}</em></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "export-api-using-matchtype"
    }}>{`Export API Using matchType`}</h3>
    <p>{`To export entities that represent the HDFS path, use the Export API using the `}<em parentName="p">{`matchType`}</em>{` option. Details can be found `}<a parentName="p" {...{
        "href": "#/ExportAPI"
      }}>{`here`}</a>{`.`}</p>
    <h3 {...{
      "id": "example-using-curl-calls"
    }}>{`Example Using CURL Calls`}</h3>
    <p>{`Below are sample CURL calls perform an export operation on the `}<em parentName="p">{`Sample HDFS Setup`}</em>{` shown above.`}</p>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
      {`curl -X POST -u adminuser:password -H "Content-Type: application/json" -H "Cache-Control: no-cache" -d '{
    "itemsToExport": [
            { "typeName": "hdfs_path", "uniqueAttributes": { "qualifiedName": "FinanceAll" } }
    ],
    "options": {
     "fetchType": "full",
     "matchType": "startsWith"
    }
}' "http://localhost:21000/api/atlas/admin/export" > financeAll.zip`}
    </SyntaxHighlighter>
    <h3 {...{
      "id": "automatic-creation-of-hdfs-entities"
    }}>{`Automatic Creation of HDFS entities`}</h3>
    <p>{`Given that HDFS entity creation is a manual process. The Export API offers a mechanism for the creation of requested HDFS entities.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;